module.exports = __webpack_public_path__ + "img/20191209165545589.d71c4497.jpg";